/* eslint-disable import/no-anonymous-default-export */
export default function(url){
    let width= 0.80*window.innerWidth
    let height=0.85*window.innerHeight
    let left=0.10*window.innerWidth
    let top=0.10*window.innerHeight
    window.open(url,'',`width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
    return null;
}